import { FaRegBell } from 'react-icons/fa';
import './Notifications.css';

const NotificationIcon = ({ onClick, active = true, read = false }) => {
  const wrapperClass = 'te-notification-icon te-icon-btn align-items-center justify-content-center position-relative';
  return (
    <div className={wrapperClass} onClick={onClick}>
      <div className="position-relative p-0">
        <FaRegBell size={16} />
        {active && !read ? <span className="te-notification-dot position-absolute rounded-circle"></span> : null}
      </div>
    </div>
  );
};

export default NotificationIcon;
